<div class="playbooks-marketplace">
  <div class="select-container">
    <app-multi-select
      [placeHolder]="'common.select' | labelsProvider"
      [options$]="platformOptions$"
      (optionOnSelection)="selectPlatform($event)"
      [withSelectAll]="true"
      [selectedIds]="selectedPlatformIds"
    >
    </app-multi-select>
  </div>

  <div class="templates-cards-header">
    {{ 'playbooksMarketplace.title' | labelsProvider }}
  </div>

  <div class="templates-cards-container" *ngIf="playbookTemplateCards.value.length > 0">
    <app-playbook-template-card
      *ngFor="let card of playbookTemplateCards | async"
      [card]="card"
      (cardActionClick)="selectTemplate($event)"
    >
    </app-playbook-template-card>
  </div>
  <div class="templates-cards-header" *ngIf="playbookTemplateCards.value.length === 0">
    {{ 'playbooksMarketplace.noTemplatesAvailableMessage' | labelsProvider }}
  </div>
</div>
